<template>
          <BreadCrumb PageTitle=" Modifier un marchand" />

    <EditUsager />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditUsager from "@/components/Usager/EditUsager.vue";
  
    export default defineComponent({
      name: "EditUsagerPage",
      components: {
        BreadCrumb,
        EditUsager,
      },
    });
  </script>